import Icon from '../components/Icon.vue'

Icon.register({
  bell: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 512C259.3 512 288 483.4 288 448H160C160 483.4 188.7 512 224 512zM439.4 362.3C420.1 341.5 383.9 310.3 383.9 208 383.9 130.3 329.4 68.1 256 52.8V32C256 14.3 241.7 0 224 0S192 14.3 192 32V52.8C118.6 68.1 64.1 130.3 64.1 208 64.1 310.3 27.9 341.5 8.6 362.3 2.6 368.7-0.1 376.4 0 384 0.1 400.4 13 416 32.1 416H415.9C435 416 447.9 400.4 448 384 448.1 376.4 445.4 368.7 439.4 362.3z'
      }
    ]
  }
})
